import axios from 'axios';
import Idx from 'idx';
import Connection from './Connection';
const isReleaseBuild = process.env.NODE_ENV === 'production';
declare const window: any;
const getAxiosInstance = ({ authToken = '', isCloudFrontURL = false, noCache = false }) => {
  const instance = axios.create({
    baseURL: `${Connection.getBaseUrl(isCloudFrontURL)}/`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    timeout: 1000 * 60
  });

  // Add a request interceptor
  instance.interceptors.request.use(
    (config: any) => {
      config.headers['Authorization'] = `Bearer ${authToken}`;
      config.headers['User-Agent'] = window?.OS ? window.OS : 'Desktop';
      if (!isReleaseBuild) {
        config.headers['request-startTime'] = new Date().getTime();
      }
      if (noCache) {
        config.headers['Cache-Control'] = 'no-cache';
        config.headers['Pragma'] = 'no-cache';
        config.headers['Expires'] = '0';
      }
      return config;
    },
    (error: any) => Promise.reject(error)
  );

  // Add a response interceptor
  instance.interceptors.response.use(
    (response: any) => {
      if (!isReleaseBuild) {
        const currentTime = new Date().getTime();
        const startTime = response.config.headers['request-startTime'];
        response.headers['request-duration'] = currentTime - startTime;
        console.log(
          'response time ',
          response.headers['request-duration'] / 1000 + 's ',
          'url ',
          response.config.url
        );
      }
      return response;
    },
    (error: any) => {
      if (Idx(error, (_) => _.response.data)) {
        const data = error.response.data;
        if (
          !(
            typeof data === 'string' &&
            (data.includes('502 Bad Gateway') ||
              data.includes('503 Service Temporarily Unavailable'))
          )
        )
          return Promise.reject({ ...data, httpCode: error.response.status });
      }
      if (Idx(error, (_) => _.response)) {
        return Promise.reject(error.response);
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default getAxiosInstance;
